export default __webpack_public_path__ + "static/media/monthly_view_of_calendar.55e6f93b.png";